/* RON-PICHE — Page-specific behaviors (Vague 1)
 *
 * À uploader dans Shopify Theme → Edit code → Assets → rp-pages.js
 * À référencer dans theme.liquid (avant </body>) :
 *   {{ 'rp-pages.js' | asset_url | script_tag }}
 *
 * Couvre :
 *  - Comparison slider (drag/touch/keyboard) — guarded by .compare__slider
 *  - Sticky CTA mobile show/hide — .sticky-cta
 *  - Reveal-on-scroll animation — .reveal
 *  - Hotspots PDP (tap-to-toggle) — .hotspot-btn / .hotspot-popover (à venir)
 *
 * Tous guards défensifs (ne fait rien si l'élément n'existe pas sur la page).
 */
(function () {
  'use strict';

  // ---------- 1. Comparison slider ----------
  document.querySelectorAll('.compare__slider').forEach(function (slider) {
    var after = slider.querySelector('.compare__slider-after');
    var handle = slider.querySelector('.compare__handle');
    if (!after || !handle) return;

    function update(percent) {
      percent = Math.max(0, Math.min(100, percent));
      after.style.clipPath = 'inset(0 0 0 ' + percent + '%)';
      handle.style.left = percent + '%';
      slider.setAttribute('aria-valuenow', String(Math.round(percent)));
    }
    function move(clientX) {
      var rect = slider.getBoundingClientRect();
      update(((clientX - rect.left) / rect.width) * 100);
    }
    var dragging = false;
    slider.addEventListener('mousedown', function (e) { dragging = true; move(e.clientX); });
    window.addEventListener('mousemove', function (e) { if (dragging) move(e.clientX); });
    window.addEventListener('mouseup', function () { dragging = false; });
    slider.addEventListener('touchstart', function (e) { move(e.touches[0].clientX); }, { passive: true });
    slider.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
    slider.addEventListener('click', function (e) {
      if (window.matchMedia('(pointer: coarse)').matches) {
        var rect = slider.getBoundingClientRect();
        update(((e.clientX - rect.left) / rect.width) * 100);
      }
    });
    slider.addEventListener('keydown', function (e) {
      var c = parseInt(slider.getAttribute('aria-valuenow') || '50', 10);
      if (e.key === 'ArrowLeft') update(c - 5);
      if (e.key === 'ArrowRight') update(c + 5);
    });
  });

  // ---------- 2. Sticky CTA mobile (show after 50vh, hide near final CTA) ----------
  if (!window.matchMedia('(min-width: 768px)').matches) {
    document.querySelectorAll('.sticky-cta').forEach(function (sticky) {
      var hideAnchorSelector = sticky.getAttribute('data-hide-anchor') || '#cta-final';
      var hideAnchor = document.querySelector(hideAnchorSelector);
      var scrolled = false;
      var hideAnchorVisible = false;

      function update() {
        var show = scrolled && !hideAnchorVisible;
        if (show) {
          sticky.removeAttribute('hidden');
          requestAnimationFrame(function () { sticky.setAttribute('data-visible', ''); });
        } else {
          sticky.removeAttribute('data-visible');
          setTimeout(function () { if (!scrolled || hideAnchorVisible) sticky.setAttribute('hidden', ''); }, 250);
        }
      }
      window.addEventListener('scroll', function () {
        scrolled = window.scrollY > window.innerHeight * 0.5;
        update();
      }, { passive: true });
      if (hideAnchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          hideAnchorVisible = entries[0].isIntersecting;
          update();
        }, { rootMargin: '0px 0px -100px 0px' }).observe(hideAnchor);
      }
    });
  }

  // ---------- 3. Reveal-on-scroll ----------
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    document.querySelectorAll('.reveal').forEach(function (el) { revealObserver.observe(el); });
  }

  // ---------- 4. Hotspots tap-to-toggle (PDP) — à venir ----------
  // Will be added when PDP push lands
})();